(function () {
  'use strict';

  const SCROLL_THRESHOLD = 5;
  const UI_UPDATE_DELAY = 150;
  const SCROLL_ANIMATION_DELAY = 300;
  const FALLBACK_INIT_DELAY = 1000;

  let initialized = false;

  function initScrollIndicators() {
    if (initialized) return;
    const section = document.querySelector('.desktop-quick-links-menu');
    if (!section) return;

    const container = section.querySelector('.quick-links-container');
    if (!container) return;

    const showIndicators = container.dataset.showScrollIndicators === 'true';
    if (!showIndicators) return;

    const nav = container.querySelector('.quick-links-desktop__navigation');
    if (!nav) return;

    const menuList = nav.querySelector('.quick-links-menu-desktop__menu');
    if (!menuList) return;

    const leftIndicator = container.querySelector('.quick-links-scroll-indicator--left');
    const rightIndicator = container.querySelector('.quick-links-scroll-indicator--right');

    if (!leftIndicator || !rightIndicator) return;

    container.setAttribute('data-show-scroll-indicators', 'true');

    let scrollDebounceTimer = null;

    function updateScrollIndicators() {
      if (scrollDebounceTimer) {
        cancelAnimationFrame(scrollDebounceTimer);
      }

      scrollDebounceTimer = requestAnimationFrame(function () {
        const scrollLeft = nav.scrollLeft;
        const scrollWidth = nav.scrollWidth;
        const clientWidth = nav.clientWidth;

        const isScrollable = scrollWidth > clientWidth;
        if (!isScrollable) {
          leftIndicator.style.display = 'none';
          rightIndicator.style.display = 'none';
          container.classList.remove('show-left-indicator', 'show-right-indicator');
          return;
        }

        const maxScroll = scrollWidth - clientWidth;
        const isAtStart = scrollLeft <= SCROLL_THRESHOLD;
        const isAtEnd = scrollLeft >= maxScroll - SCROLL_THRESHOLD;

        leftIndicator.style.display = isAtStart ? 'none' : 'flex';
        rightIndicator.style.display = isAtEnd ? 'none' : 'flex';
        leftIndicator.tabIndex = isAtStart ? -1 : 0;
        rightIndicator.tabIndex = isAtEnd ? -1 : 0;

        container.classList.toggle('show-left-indicator', !isAtStart);
        container.classList.toggle('show-right-indicator', !isAtEnd);
      });
    }

    leftIndicator.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const scrollLeft = nav.scrollLeft;
      const containerWidth = nav.clientWidth;

      let targetScroll = Math.max(scrollLeft - containerWidth, 0);

      nav.scrollTo({
        left: targetScroll,
        behavior: 'smooth',
      });

      setTimeout(updateScrollIndicators, SCROLL_ANIMATION_DELAY);
    });

    rightIndicator.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const scrollLeft = nav.scrollLeft;
      const containerWidth = nav.clientWidth;
      const maxScroll = nav.scrollWidth - containerWidth;

      let targetScroll = Math.min(scrollLeft + containerWidth, maxScroll);

      nav.scrollTo({
        left: targetScroll,
        behavior: 'smooth',
      });

      setTimeout(updateScrollIndicators, SCROLL_ANIMATION_DELAY);
    });

    updateScrollIndicators();

    nav.addEventListener('scroll', updateScrollIndicators, { passive: true });

    let resizeDebounceTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeDebounceTimer);
      resizeDebounceTimer = setTimeout(updateScrollIndicators, UI_UPDATE_DELAY);
    });

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(updateScrollIndicators);
      resizeObserver.observe(nav);
      resizeObserver.observe(menuList);
    }

    initialized = true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initScrollIndicators);
  } else {
    initScrollIndicators();
  }

  setTimeout(function () {
    if (!initialized) {
      initScrollIndicators();
    }
  }, FALLBACK_INIT_DELAY);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initialized = false;
      setTimeout(initScrollIndicators, UI_UPDATE_DELAY);
    });

    document.addEventListener('shopify:block:select', function (event) {
      initialized = false;
      setTimeout(initScrollIndicators, UI_UPDATE_DELAY);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      initialized = false;
      setTimeout(initScrollIndicators, UI_UPDATE_DELAY);
    });
  }
})();
